export default __webpack_public_path__ + "static/media/mui-monitor.0bb342d6.svg";